export enum BackupFilterText {
  All = 'All',
  Enabled = 'Backup enabled',
  Disabled = 'Backup disabled'
}
